import { semitonesToFrequency } from "@/utils/semitonesToFrequency";

export const applyPitchesUsingUpdatedPitchRequest = async (
  updatedPitchRequest: Promise<number[]>,
  pitches: number[]
) => {
  const x = await updatedPitchRequest;
  return [
    ...x.slice(0, 300),
    ...pitches.map((i) => (i === 0 ? 0 : semitonesToFrequency(i))),
    ...x.slice(-300),
  ];
};
